import { useEffect } from "react";

export const useLockBodyScroll = (isLocked: boolean = true) => {
    useEffect(() => {
        if (!isLocked) return;

        // Save original body style
        const originalStyle = window.getComputedStyle(document.body).overflow;

        // Prevent scrolling on mount
        document.body.style.overflow = "hidden";

        // Re-enable scrolling when component unmounts
        return () => {
            document.body.style.overflow = originalStyle;
        };
    }, [isLocked]);
};
